var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: " currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.435 6.599a10.056 10.056 0 0 1 6.683-4.436c5.477-.987 10.724 2.618 11.718 8.051.995 5.433-2.64 10.637-8.117 11.623a10.113 10.113 0 0 1-9.82-3.774A9.917 9.917 0 0 1 2 13.786m1.435-7.187H7.33m-3.894 0V2.163M16.5 8.5l-5.383 5.289L7.5 11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.9a818c07135f992dfed41f4f17e8d24d.svg";
export { ForwardRef as ReactComponent };